@if (hasChartData()) {
  <div class="position-relative mx-auto" style="height:60vh;max-height:500px;">
    <canvas baseChart [data]="barChartData()" [options]="barChartOptions()" type="bar"></canvas>
  </div>
}
